module.exports = __webpack_public_path__ + "static/media/25532034_1703513913057126_8981498255888721348_o.5a0eebea.jpg";